export class Pais {
    id = 0;
    nome = '';
    sigla = '';
}